<template>
  <div class="popup_wrap">
    <div class="btn_wrap mt30"><a class="btn_bg line wdful" @click="onOpenWaitClick">예매 알림 신청</a></div>
    <!-- 레이어팝업 -->
    <modal @close="closeModal" :open="modal.open" title="예약대기">
      <!-- default 슬롯 콘텐츠 -->
      <div>
        <p class="colorbox mb20">신청하실 체험자 수 보다 남은 잔여석이 부족할 시, 예매 알림 신청을 하시면 잔여석이 발생될때 연락을 받으실 수 있습니다.</p>
        <h5 class="stitle2 mb10">신청 내용</h5>
        <div class="colorBox">
          <ul class="inputBox">
            <li>
              <label>대상상품</label>
              <span>
                {{ productItem.mrktnPdNm }}
                <br />
                {{ ticket.date }}, {{ ticket.mrktnScheSeqNo }}회차({{ ticket.scheTime }})
              </span>
            </li>
            <li>
              <label>체험자수</label>
              <span>{{ ticket.experPcnt }}</span>
            </li>
            <li>
              <label>신청자</label>
              <span>{{ userName }}</span>
            </li>
            <li>
              <label for="w-orgName">단체명</label>
              <span><input type="text" id="w-orgName" v-model="orgName" maxlength="100" placeholder="신청단체명" /></span>
            </li>
            <li>
              <label for="w-tel">연락처</label>
              <span>
                <input type="tel" id="w-tel" v-model="userPhoneNum" maxlength="13" placeholder="전화번호" />
              </span>
            </li>
          </ul>
        </div>
      </div>
      <!-- /default -->
      <!-- footer 슬롯 콘텐츠 -->
      <template slot="footer">
        <div class="btn_wrap">
          <a class="all-half btn btn_bg gray" @click="() => onButtonClick(false)">닫기</a>
          <a class="all-half btn btn_bg color" @click="requestWait">신청</a>
        </div>
      </template>
      <!-- /footer -->
    </modal>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Modal from '@/components/common/Modal.vue';
import { postWait } from '@/api/api_reserve';
import { isLoggedIn } from '@/utils/reserve';

export default {
  components: { Modal },
  props: ['value'],
  data() {
    return {
      modal: {
        open: false,
      },
      orgName: '',
      userPhoneNum: '',
    };
  },
  computed: {
    ...mapState({
      userName: (state) => state.ui.userName,
    }),
    ...mapState('reserve', ['productItem', 'ticket']),
  },
  watch: {},
  methods: {
    openModal() {
      this.modal.open = true;
    },
    closeModal() {
      this.modal.open = false;
    },
    onOpenWaitClick() {
      if (isLoggedIn()) {
        this.openModal();
      }
    },
    onButtonClick(agree) {
      this.$emit('input', agree);
      this.closeModal();
    },
    async requestWait() {
      const orgName = this.orgName || '';
      const userPhoneNum = (this.userPhoneNum || '').replace(/-/g, '');

      if (!orgName) {
        alert('단체명을 입력해주세요.');
        return false;
      }

      if (!userPhoneNum) {
        alert('연락처를 입력해주세요.');
        return false;
      }

      const reserveWait = {
        pdNo: this.productItem.mrktnPdNo,
        pdDiv: this.productItem.pdDiv,
        expVisitRvdt: this.ticket.date,
        scheSeqNo: this.ticket.mrktnScheSeqNo,
        experPcnt: this.ticket.experPcnt,
        //hpUserId: '',
        //userName: '',
        orgName: this.orgName,
        userPhoneNum: this.userPhoneNum,
      };

      const data = await postWait(reserveWait);
      if (data.success) {
        alert(data.response.message);
        this.closeModal();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.inputBox > li {
  width: 100%;
  margin: 0;
}
</style>
